export default __webpack_public_path__ + "static/media/Coin1.f5dbe0cf.webp";